<sf-card icon="circle-info" cardTitle="Customer Details" [showCollapseButton]="true">
    <ng-container [formGroup]="form">
        <sf-input label="Customer" inputId="customer" formControlName="customerName"></sf-input>
        <sf-input label="Email" inputId="email" formControlName="emailAddress"></sf-input>
        @if (existingWorkAddress()) {
            <sf-input-textarea
                label="Work Address"
                inputId="workAddress"
                [rows]="2"
                [maxLength]="1000"
                formControlName="workAddress" />
        } @else {
            <hr />
            <sf-postcode-lookup
                label="Postcode"
                inputId="postcode"
                formControlName="postcode"
                (onAddressChange)="selectAddress($event)" />
            <sf-input label="Address Line 1" inputId="addressLine1" formControlName="addressLine1"></sf-input>
            <sf-input label="Address Line 2" inputId="addressLine2" formControlName="addressLine2"></sf-input>
            <sf-input label="Town" inputId="town" formControlName="town"></sf-input>
            <sf-input label="County" inputId="county" formControlName="county"></sf-input>
        }
    </ng-container>
</sf-card>
